import type { DialogAlertProps } from './DialogAlert.types'
import Dialog from '../Dialog'

const DialogAlert = (props: DialogAlertProps) => {
  return <Dialog {...props} />
}

DialogAlert.displayName = 'BaseDialogAlert'

export default DialogAlert
